<template>
    <div class="my-content">
        <standard-header left-div="back" title="내가 참여한 컨텐츠" />

        <!-- 내가 참여한 컨텐츠: No Data -->
        <div class="course-no-list-section" v-if="memberCourseList.length === 0">아직 업로드된 동화가 없습니다.<br>여러분의 컨텐츠로 채워주세요 :)</div>

        <!-- 리스트 in 내가 참여한 컨텐츠 -->
        <!-- ion-item-sliding 적용 (삭제 버튼) -->
        <ul class="course-list-vertical">
            <li class="on-sliding" v-for="(course, index) in memberCourseList">
                <ion-list lines="none">
                    <ion-item-sliding>
                        <ion-item>
                            <div class="course-image">
                                <img v-if="course.thumb_url !== null && course.thumb_url !== ''" v-bind:src="course.thumb_url" />
                                <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/content/course/201908/da2302a0d96147c5b40d43e5e94782cf.png" />
                                <div class="play-image" v-show="course.screening_yn === 'Y'" @click="playLecture(course.course_no)">
                                    <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/lecture-white-player.png" />
                                </div>
                                <div class="screening-image">
                                    <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/mycontent/ranking.png" />
                                </div>
                                <div class="screening-name" v-show="course.screening_yn === 'N'">심사중</div>
                                <div class="screening-name" v-show="course.screening_yn === 'Y' && course.screening_result === '10'">승인</div>
                                <div class="screening-name" v-show="course.screening_yn === 'Y' && course.screening_result === '20'">반려</div>
                            </div>
                            <div class="course-info">
                                <div class="title">
                                    <div class="text word_comma_2" v-if="course.screening_yn === 'Y'" @click="playLecture(course.course_no)">{{ course.course_name }}</div>
                                    <div class="text word_comma_2" v-else>{{ course.course_name }}</div>
                                </div>
                                <div class="etc">
                                    <div class="subject">{{ course.category_name }}</div>
                                    <div class="date">{{ course.regist_date }}</div>
                                    <div class="likes">
                                        <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/comment-hand.png" />
                                        {{ course.like_count }}
                                    </div>
                                    <div class="views">
                                        <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/views.png" />
                                        {{ course.view_count }}
                                    </div>
                                </div>
                                <div class="reject_reason" v-show="course.screening_yn === 'Y' && course.screening_result === '20'">
                                    * 반려사유 : {{ course.reject_reason }}
                                </div>
                            </div>
                        </ion-item>
                        <ion-item-options side="end">
                            <ion-item-option @click="deleteListEvent(index)">삭제</ion-item-option>
                        </ion-item-options>
                    </ion-item-sliding>
                </ion-list>
            </li>
        </ul>

        <footer-toolbar />
    </div>
</template>

<script>
    import * as biz from '../../utils/biz';
    import * as ajax from '../../utils/ajax';
    import * as alert from '../../utils/alert';
    import StandardHeader from "../../components/header/StandardHeader";
    import FooterToolbar from "../../components/footer/FooterToolbar";

    export default {
        name: "MyContent",
        components: {StandardHeader, FooterToolbar},
        data() {
            return {
                memberCourseList: []
            }
        },
        created() {
            if (!biz.isLogin(this))
                this.$router.push("/login");

            this.$store.state.toolbarActivePosition = "join";
            this.$store.state.basicPlayerVisiblity = true;
        },
        mounted() {
            this.getMemberCourseList();
        },
        methods: {
            playLecture(courseNo) {
                biz.playAudioPlayer(courseNo);
            },
            getMemberCourseList() {
                const url = "/api/contents/member/course/member";
                const param = {};
                ajax.Post(this, url, param, function(ref, data) {
                    ref.memberCourseList = data;
                });
            },
            deleteListEvent(index) {
                const url = "/api/contents/member/course/" + this.memberCourseList[index].course_no;
                alert.alertConfirm(this, "삭제 하시겠습니까?", '확인', '취소', function(ref) {
                    ajax.Delete(ref, url, function(ref, data) {
                        alert.alert("교과서가 삭제 되었습니다.", "확인");

                        ref.getMemberCourseList();
                    });
                });
            }
        },
        computed: {
        }
    }
</script>

<style scoped lang="scss">
    div.my-content {
        overflow-y: auto;
        padding-bottom: 110px;

        div.reject_reason {
            margin: 5px 0 0 0;
            font-size: $font-base12;
            color: $font-secondary-color;
        }
    }
</style>